/* The Hollow Harvest · sfogliatore delle pagine vere.
   Serve la sezione dei dieci libri e la sezione Look inside.

   Regole rispettate qui dentro:
   - funziona col dito, col mouse e con la sola tastiera;
   - il fuoco resta dentro la finestra aperta finche' non si chiude;
   - con le animazioni di sistema disattivate si spegne il movimento, mai la
     funzione (bug grave gia' preso una volta su questo sito);
   - le pagine si caricano solo quando servono, cosi' la home resta leggera. */
(function () {
  'use strict';

  var apri = document.querySelectorAll('[data-hh-pages]');
  if (!apri.length) return;

  var box = null, img = null, nome = null, conta = null, prev = null, next = null, piede = null;
  var pagine = [], indice = 0, sorgente = null;

  function costruisci() {
    box = document.createElement('div');
    box.className = 'hh-flip';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Pages');
    box.hidden = true;
    box.innerHTML =
      '<div class="hh-flip__bar">' +
        '<p class="hh-flip__name"></p>' +
        '<span class="hh-flip__count"></span>' +
        '<button class="hh-flip__close" type="button" aria-label="Close">&#215;</button>' +
      '</div>' +
      '<div class="hh-flip__stage">' +
        '<button class="hh-flip__nav hh-flip__nav--prev" type="button" aria-label="Previous page">&#8249;</button>' +
        '<img class="hh-flip__img" alt="">' +
        '<button class="hh-flip__nav hh-flip__nav--next" type="button" aria-label="Next page">&#8250;</button>' +
      '</div>' +
      '<p class="hh-flip__foot"></p>';
    document.body.appendChild(box);

    img = box.querySelector('.hh-flip__img');
    piede = box.querySelector('.hh-flip__foot');
    nome = box.querySelector('.hh-flip__name');
    conta = box.querySelector('.hh-flip__count');
    prev = box.querySelector('.hh-flip__nav--prev');
    next = box.querySelector('.hh-flip__nav--next');

    collegaLente();

    prev.addEventListener('click', function () { vai(indice - 1); });
    next.addEventListener('click', function () { vai(indice + 1); });
    box.querySelector('.hh-flip__close').addEventListener('click', chiudi);
    box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('hh-flip__stage')) chiudi(); });

    /* scorrimento col dito */
    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = ingrandita ? null : e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) vai(indice + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  /* --- la lente: un tocco ingrandisce, si trascina, un altro tocco chiude --- */
  var ingrandita = false, trascino = false, px0 = 0, py0 = 0, sx0 = 0, sy0 = 0;

  function azzeraLente() {
    ingrandita = false;
    trascino = false;
    sx0 = 0; sy0 = 0;
    if (!img) return;
    img.classList.remove('is-zoomed');
    /* si scrive in `transform`, non in `translate`/`scale`: WebKit non applica
       le proprieta' singole qui, e la lente non ingrandiva su Safari */
    img.style.transform = '';
    img.style.cursor = 'zoom-in';
  }

  function collegaLente() {
    img.addEventListener('click', function (e) {
      e.stopPropagation();
      ingrandita = !ingrandita;
      img.classList.toggle('is-zoomed', ingrandita);
      img.style.cursor = ingrandita ? 'grab' : 'zoom-in';
      if (!ingrandita) { sx0 = 0; sy0 = 0; }
      img.style.transform = ingrandita
        ? 'translate(' + sx0 + 'px, ' + sy0 + 'px) scale(2)'
        : '';
    });
    img.addEventListener('pointerdown', function (e) {
      if (!ingrandita) return;
      trascino = true; px0 = e.clientX; py0 = e.clientY;
      img.setPointerCapture(e.pointerId);
      img.style.cursor = 'grabbing';
    });
    img.addEventListener('pointermove', function (e) {
      if (!trascino) return;
      img.style.transform = 'translate(' + (sx0 + e.clientX - px0) + 'px, ' +
                            (sy0 + e.clientY - py0) + 'px) scale(2)';
    });
    img.addEventListener('pointerup', function (e) {
      if (!trascino) return;
      trascino = false;
      sx0 += e.clientX - px0; sy0 += e.clientY - py0;
      img.style.cursor = 'grab';
    });
  }

  function vai(n) {
    if (n < 0 || n >= pagine.length) return;
    indice = n;
    azzeraLente();   /* la pagina nuova si apre sempre intera */
    img.src = pagine[n];
    img.alt = 'Page ' + (n + 1) + ' of ' + pagine.length;
    conta.textContent = (n + 1) + ' / ' + pagine.length;
    prev.disabled = n === 0;
    next.disabled = n === pagine.length - 1;
    /* la pagina dopo si scarica in anticipo, cosi' il passaggio e' immediato */
    if (pagine[n + 1]) { var p = new Image(); p.src = pagine[n + 1]; }
  }

  function apriCon(lista, titolo, sorg, partenza, riga) {
    if (!box) costruisci();
    pagine = lista;
    sorgente = sorg;
    nome.textContent = titolo || '';
    /* la riga in fondo cambia con quello che si sta guardando: pagine, tavole
       o mappe. Se chi apre non la passa, resta quella delle pagine. */
    piede.textContent = riga || 'These are the real pages, at full size.';
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    vai(partenza || 0);
    box.querySelector('.hh-flip__close').focus();
  }

  function chiudi() {
    azzeraLente();
    box.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var ridotto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () {
      box.hidden = true;
      if (sorgente) sorgente.focus();
    }, ridotto ? 0 : 200);
  }

  document.addEventListener('keydown', function (e) {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') { chiudi(); return; }
    if (e.key === 'ArrowLeft') { vai(indice - 1); return; }
    if (e.key === 'ArrowRight') { vai(indice + 1); return; }
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('button:not([disabled])');
    if (!f.length) return;
    var primo = f[0], ultimo = f[f.length - 1];
    if (e.shiftKey && document.activeElement === primo) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primo.focus(); }
  });

  apri.forEach(function (b) {
    b.addEventListener('click', function () {
      var lista = (b.getAttribute('data-hh-pages') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!lista.length) return;
      var da = parseInt(b.getAttribute('data-hh-start') || '0', 10);
      apriCon(lista, b.getAttribute('data-hh-book') || '', b, isNaN(da) ? 0 : da, b.getAttribute('data-hh-foot'));
    });
  });
})();
